import { useContext } from 'react'
import { MarkupContext } from '../../providers/Markup'
import Picture from '../helpers/Picture'
import MetaBadge from '../helpers/MetaBadge'
import { LockClosedIcon } from '@heroicons/react/24/solid'
import HeroTitle from '../helpers/CardListingHeroTitle'
import ButtonEl from '../helpers/ctas/Button'
import { dataLayerPush } from '../../helpers/thirdparty'
import { resolveCTALabel } from '../../helpers/ctaLabel'

const stripHtml = (html) => (html ? html.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim() : '')

const HeroImageCard = ({ cardItem, i, isList = false, isMember = null, onLockedClick }) => {
  const { createMarkup } = useContext(MarkupContext)
  const ctaLinkItems = cardItem.ctaLinkItem || []

  const badgeData = cardItem?.metaBadgeData || {}
  const firstCategoryTag = badgeData?.categoryTags?.[0]
  const isVisuallyLocked = !!badgeData.isLocked && isMember === false

  const handleCardClick = (e) => {
    if (isVisuallyLocked) {
      e.preventDefault()
      dataLayerPush({ event: 'login_intent', click_text: stripHtml(cardItem.title), member_only: true }, e.currentTarget)
      onLockedClick?.()
      return
    }
    dataLayerPush({
      event: 'article_click',
      click_text: stripHtml(cardItem.title),
      category: badgeData.categoryTags?.length ? badgeData.categoryTags.join(', ') : undefined,
      member_only: false,
    }, e.currentTarget)
  }

  return (
    <div className={`w-full ${isList ? 'mb-12' : ''}`}>
      {!isList && (
        <Picture
          desktopImage={cardItem.desktopImage}
          mobileImage={cardItem.mobileImage}
          className={`mx-auto mb-8 aspect-video rounded-e-3xl rounded-bl-3xl`}
        />
      )}
      {(firstCategoryTag || badgeData?.readTime || badgeData?.publicationDate) && (
        <div className="flex flex-row items-center w-full mb-4">
          <div className="flex-1">
            {(firstCategoryTag || badgeData?.readTime) && (
              <MetaBadge
                primaryText={firstCategoryTag}
                secondaryText={badgeData?.readTime}
                isLocked={!!badgeData?.isLocked}
                icon={badgeData?.isLocked ? <LockClosedIcon className="w-3.5 h-3.5" aria-hidden="true" /> : null}
                tagType={!!badgeData?.isLocked ? 'locked_news_articles' : 'unlocked_news_articles'}
              />
            )}
          </div>
          {badgeData?.publicationDate && (
            <span className="text-xs font-normal text-(--sb-common-base-body-text-color) shrink-0">
              {badgeData?.publicationDate}
            </span>
          )}
        </div>
      )}
      <div className="col-start-2 col-span-7 md:col-span-3 lg:col-span-5">
        {cardItem.title && (
          <HeroTitle type="curated" cardItem={cardItem} idx={i} className={'text-(--color-primary-text)'} onCardClick={handleCardClick} />
        )}
        {cardItem.description && (
          <div
            className="mt-4 !text-(--sb-common-base-body-text-color)"
            data-rte="true"
            dangerouslySetInnerHTML={createMarkup(cardItem.description)}
          />
        )}
      </div>
      {ctaLinkItems.length !== 0 && (
        <div className={`flex gap-6 ${!isList ? 'mt-4 md:mt-8' : ''}`}>
          {ctaLinkItems.map((ctaLinkItem, idx) => (
            <ButtonEl
              key={ctaLinkItem.link?.url || idx}
              link={ctaLinkItem.link}
              label={resolveCTALabel(cardItem, ctaLinkItem, isMember)}
              theme={ctaLinkItem.linkType.toLowerCase()}
              icon={ctaLinkItem.linkIconClass}
              position={ctaLinkItem.linkPosition}
              className={`!text-sm !font-normal${ctaLinkItem.linkType.toLowerCase() === 'text' ? ' !text-(--color-primary-text)' : ''}`}
              onClick={handleCardClick}
            />
          ))}
        </div>
      )}
    </div>
  )
}

export default HeroImageCard
